import { html, LitElement } from 'lit-element';
import { repeat } from 'lit-html/directives/repeat';
import style from './base-table.css';
import '../ki-icon/ki-icon';
import { template } from '../../common/util';
import Mix from '../../common/Mix';
import PropertyDefaultValue from '../../common/PropertyDefaultValue';
import { unsafeHTML } from 'lit-html/directives/unsafe-html';

export default class BaseTable extends Mix(LitElement, PropertyDefaultValue) {
  // language=CSS
  static styles = style;

  constructor() {
    super();
    this.data = [];
  }

  get renderingData() {
    return this.data;
  }

  get renderingColumns() {
    // for customize
    return (
      this.columns ||
      Object.keys(this.renderingData[0] || {}).map((key, i) => {
        return {
          field: key,
          label: key,
          sortable: true,
          format: this.renderingData[i].format
        };
      })
    );
  }

  static get properties() {
    return {
      idproperty: {
        type: String,
      },
      data: {
        type: Array,
      },
      /*
       *  [
       *   {
       *     field: String,
       *     label: String,
       *     renderHeaderCell: function.
       *     renderCell: function
       *   }
       * ]
       *
       * */
      columns: {
        type: Array,
      },
      renderRow: {
        type: Function,
      },
    };
  }

  _renderHeader() {
    return html`
      <div class="header">
        <div class="row">
          ${repeat(
            this.renderingColumns,
            col => col.field,
            col => this._renderHeaderCell(col),
          )}
        </div>
      </div>
    `;
  }

  // eslint-disable-next-line class-methods-use-this
  _renderHeaderCell(col) {
    return col.renderHeaderCell
      ? col.renderHeaderCell()
      : html`
          <div class="cell col-${col.field}">
            <div style=${col.labelCss || col.css || ''} class="header-content" title="${col.label}">
              <span class="col-label">${unsafeHTML(col.label)}</span>
            </div>
          </div>
        `;
  }

  _renderData() {
    // language=html
    const keyFn = this.idproperty && (item => item[this.idproperty]);
    return html`
      <div class="body">${repeat(this.renderingData || [], keyFn, this.renderRow.bind(this))}</div>
    `;
  }

  renderRow(item) {
    // can be override;
    // language=html
    return html`
      <div
        class="row"
        @click="${() => {
          this._onRowClick(item);
        }}"
      >
        ${this.renderingColumns.map(col => this._renderCell(col, item))}
      </div>
    `;
  }

  // eslint-disable-next-line class-methods-use-this
  _renderCell(col, item) {
    return col.renderCell
      ? col.renderCell(item)
      : html`
          <div style="${col.css || ''}" class="cell col-${col.field}">
            ${col.prefix ? template(col.prefix, item) : ''}${item[col.field]}${item[col.field] &&
            col.suffix
              ? template(col.suffix, item)
              : ''}
          </div>
        `;
  }

  render() {
    // language=html
    return html`
      <div class="table" part="table">${this._renderHeader()} ${this._renderData()}</div>
    `;
  }

  _onRowClick(item) {
    this.dispatchEvent(
      new CustomEvent('row-click', {
        detail: {
          data: item,
        },
      }),
    );
  }
}
